import { useEffect, useState } from 'react';

/**
 * Minimaler Hash-Router.
 *
 * Hash-Routing statt History-API, weil GitHub Pages kein SPA-Rewrite kann.
 * Der Spotify-Auth-Code kommt als `?code=` in der Query und kollidiert nicht.
 */
export function useHashRoute(): string {
  const [route, setRoute] = useState(() => window.location.hash.slice(1) || '/');

  useEffect(() => {
    const onChange = () => setRoute(window.location.hash.slice(1) || '/');
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return route;
}

export function navigate(path: string): void {
  window.location.hash = path;
}

/**
 * Prueft eine Route gegen ein Muster mit `:param`-Platzhaltern.
 * Gibt die Parameter zurueck oder `null`, wenn das Muster nicht passt.
 */
export function matchRoute(
  route: string,
  pattern: string,
): Record<string, string> | null {
  const routeParts = route.split('/').filter(Boolean);
  const patternParts = pattern.split('/').filter(Boolean);
  if (routeParts.length !== patternParts.length) return null;

  const params: Record<string, string> = {};
  for (let i = 0; i < patternParts.length; i += 1) {
    const expected = patternParts[i]!;
    const actual = routeParts[i]!;
    if (expected.startsWith(':')) {
      params[expected.slice(1)] = decodeURIComponent(actual);
    } else if (expected !== actual) {
      return null;
    }
  }
  return params;
}
